import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../assets/config';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>{siteConfig.companyName}</h3>
              <p>{siteConfig.tagline}</p>
            </div>
            <p className="footer-description">
              {siteConfig.description}
            </p>
            <div className="social-links">
              <a href={siteConfig.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
                📷
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              {siteConfig.services.map((service, index) => (
                <li key={index}>{service.title}</li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
              </div>
              
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>{siteConfig.contact.address}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🕒</span>
                <span>{siteConfig.contact.workingHours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} {siteConfig.companyName}. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 